import Button from '@/components/UI/Button';
import Image from '@/components/UI/Image';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import { useGlobal } from '@/utils/useGlobal';
import { TimelineMax, TweenMax } from 'gsap';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from './index.module.scss';
const StoryNewHouse = () => {
    const { useState, useEffect, isMobile, useLang, Link } = useGlobal();
    const [showFirst, setShowFirst] = useState(false);
    const [showNext, setShowNext] = useState(false);
    let controller = null;
    const { t } = useLang('brandstory');
    const textlist = [t('newhouse.paraga'), t('newhouse.paragb'), t('newhouse.paragc')];
    const imglist = isMobile
        ? ['/img/stories/h5/newhouse/house1.jpg', '/img/stories/h5/newhouse/house2.jpg', '/img/stories/h5/newhouse/house3.jpg']
        : ['/img/stories/pc/newhouse/house1.jpg', '/img/stories/pc/newhouse/house2.jpg', '/img/stories/pc/newhouse/house3.jpg'];

    useEffect(() => {
        if (isMobile) return;
        controller = new ScrollMagic.Controller();

        const sceneA = new ScrollMagic.Scene({
            triggerElement: '.storyNewhouse', //触发元素
            offset: -700, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 500, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to(`.storyNewhouse .header`, 0.5, { opacity: 1 });

        sceneA.setTween(tweenA1);

        const sceneB = new ScrollMagic.Scene({
            triggerElement: '.storyNewhouse', //触发元素
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 500, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timelineB1 = new TimelineMax();
        const tweenB1 = TweenMax.to(`.storyNewhouse .header`, 0.3, { opacity: 0, y: -200 });
        const tweenB2 = TweenMax.to(`.storyNewhouse .nextscreen .parag0`, 0.25, { opacity: 1, y: 0 });
        const tweenB3 = TweenMax.to(`.storyNewhouse .nextscreen .parag1`, 0.25, { opacity: 1, y: 0 });
        const tweenB4 = TweenMax.to(`.storyNewhouse .nextscreen .parag2`, 0.25, { opacity: 1, y: 0 });
        const tweenB5 = TweenMax.to(`.storyNewhouse .nextscreen .imglist`, 0.25, { opacity: 1, y: 0 });
        const tweenB6 = TweenMax.to(`.storyNewhouse .nextscreen .link-border`, 0.25, { opacity: 1, y: 0 });
        timelineB1.add(tweenB1).add(tweenB2, 0.25).add(tweenB3, 0.25).add(tweenB4, 0.25).add(tweenB5, 0.25).add(tweenB6, 0.25);
        sceneB.setTween(timelineB1);

        controller.addScene(sceneA).addScene(sceneB);
    }, []);

    return (
        <div id="storyNewhouse" className={`${isMobile ? styled.mobile_newhouse : styled.newhouse} storyNewhouse content`}>
            <div className="story_newhouse__sticky">
                <div className={`${showFirst ? 'show' : ''} header`}>
                    <h5 className="screen-title">{t('menu.newhouse')}</h5>
                    <h5 className="screen-desc">{t('newhouse.title')}</h5>
                </div>
                <div className={`${showNext ? 'show' : ''} nextscreen`}>
                    {textlist.map((item, index) => (
                        <div className={`parag${index} text`} key={index}>
                            {item}
                        </div>
                    ))}
                    {isMobile ? (
                        <Swiper
                            loop
                            id="birds_swiper"
                            className="swiper_controller"
                            pagination={{ clickable: true }}
                            slidesPerView={'auto'}
                            initialSlide={0}
                            effect="cards"
                        >
                            {imglist.map((item, index) => (
                                <SwiperSlide className="imgitem" key={index}>
                                    <Image src={item} layout="fill" className="fullImgs" alt="" aria-label="" />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    ) : (
                        <div className="imglist">
                            {imglist.map((item, index) => (
                                <div className="imgitem" key={index}>
                                    <Image src={item} layout="fill" className="fullImgs" alt="" aria-label="" />
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="link-border">
                        <Link href="https://jp.ecoflow.com/pages/ecoflow-house" target="_blank">
                            <Button shape="circle" className="link-btn font-family-medium" aria-label={t('newhouse.btntext')} style={{ color: '#000' }}>
                                {t('newhouse.btntext')}
                                <span className="more">
                                    <EFArrowLeft />
                                </span>
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StoryNewHouse;
